module.exports = __webpack_public_path__ + "static/media/ruzencova-pout-pred-kostelem.6589f012.jpg";